import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { Avatar, Button, PopUp, AvatarSize, theme, LabelChip, LabelChipVariant } from '@ketch-com/deck'
import { styled } from '@mui/material/styles'
import { DataSystemCounts } from '@ketch-com/windlass/dist/dataSentry/v1/systems/systems'

const PlatformList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '8px 0',
})

const PlatformItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

const PlatformIcon = styled(Box)({
  position: 'relative',
  width: '32px',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const PlatformName = styled(Typography)({
  flex: 1,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export interface MorePlatformsModalProps {
  isOpen: boolean
  onClose: () => void
  categoryName: string
  platforms: DataSystemCounts[]
}

export const MorePlatformsModal: FC<MorePlatformsModalProps> = ({ isOpen, onClose, categoryName, platforms }) => {
  return (
    <PopUp
      title={`${categoryName} Sharing`}
      subTitle="View which systems this data category is shared with."
      variant="modal"
      isOpen={isOpen}
      onClose={onClose}
      popUpWidth="500px"
      popUpActionChildren={
        <Button color="tertiary" size="large" onClick={onClose}>
          Close
        </Button>
      }
    >
      <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
        <Box>
          <LabelChip
            title={categoryName}
            variant={LabelChipVariant.category}
            isViewOnly
            hideIcon
            sx={{ marginBottom: '24px' }}
          />
          <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
            Shared with :
          </Typography>
          <PlatformList>
            {platforms.map((platform: DataSystemCounts) => (
              <PlatformItem key={platform.dataSystem?.code}>
                <PlatformIcon>
                  {platform.dataSystem?.logoUrl ? (
                    <Avatar
                      src={platform.dataSystem?.logoUrl}
                      variant="circular"
                      borderColor={theme.palette.Black.o8}
                      size={AvatarSize.medium}
                      isLogo
                    />
                  ) : (
                    <Avatar
                      icon="NoLogo"
                      isLogo
                      textColor={theme.palette.Text.Secondary}
                      borderColor={theme.palette.Black.o8}
                      size={AvatarSize.medium}
                    />
                  )}
                </PlatformIcon>
                <PlatformName variant="smallBody">
                  {platform.dataSystem?.name || platform.dataSystem?.code}
                </PlatformName>
              </PlatformItem>
            ))}
          </PlatformList>
        </Box>
      </Box>
    </PopUp>
  )
}
